import styled from 'styled-components';
import { palette } from '../../theme/colors';
import { toRem } from '../../utils/toRem';

export const Column = styled.div`
  margin-left: 0.75rem;
  min-height: 2.75rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  &.alignItemsCenter {
    align-items: center;
  }
  &.spaceBetween {
    justify-content: space-between;
  }
`;

export const SName = styled.p`
  color: ${palette.white};
  font-family: 'Roboto-Medium';
  font-size: 14px;
  line-height: 18px;
`;

export const SLine = styled.hr`
  margin: 0.75rem 0;
  height: 1px;
  border: none;
  background-color: ${palette.prussianBlue4};
  border-radius: 49px;
`;

export const SRecipientsList = styled.ul`
  min-height: 0;
  height: 100%;
  padding-bottom: 6rem;

  /* vertical scrolling + hide scroller bar  */
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const SRecipient = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const SSeenContainer = styled.div`
  display: flex;
  align-items: center;

  .checkContainer {
    position: relative;
    width: 1rem;
    height: 11px;
    display: flex;
    align-items: flex-end;

    svg {
      position: absolute;

      :first-child {
        left: 4px;
      }
    }
  }
`;

export const SSeen = styled.p<{ seen: boolean }>`
  font-family: 'Roboto-Regular';
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: ${props => (props.seen ? palette.applGreen : palette.silver)};
  margin-right: 0.5rem;
`;

export const STitle = styled.p`
  margin-top: ${toRem(3.5)};
  color: ${palette.silver};
  font-family: 'Roboto-Regular';
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
`;

export const STitlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .availabilityChip {
    margin-top: ${toRem(6)};
  }
`;
